module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "listing backgroundList"
  }, _vm._l((_vm.listData), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "item full smooth hoverFade"
    }, [_c('div', {
      staticClass: "image hover-fade smooth pointer",
      on: {
        "click": function($event) {
          _vm.pickItem(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.getThumb(item.preview)
      }
    })]), _vm._v(" "), (_vm.currentBackgroundId == item.id) ? _c('color-list', {
      attrs: {
        "background-data": item
      }
    }) : _vm._e()], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-19eff10d!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Lists/BackgroundList.vue
// module id = 148
// module chunks = 0